import { entity } from 'simpler-state';

import { MarketCountryCode, NonWorkingDaysResponse } from '../models/fundamental/types';
import { DEFAULT_NON_WORKING_DAYS_RESPONSE } from '../store/fundamental/constants';

type MarketHoursStateType = Record<string, NonWorkingDaysResponse>;

const DEFAULT_COUNTRY = MarketCountryCode.UnitedStates;

const initialState: MarketHoursStateType = {
  [DEFAULT_COUNTRY]: DEFAULT_NON_WORKING_DAYS_RESPONSE,
};

const marketState = entity(initialState);

export default {
  get: (countryDesignation: string): NonWorkingDaysResponse => {
    const state = marketState.get();
    const country = countryDesignation || DEFAULT_COUNTRY;
    return state[country] || state[DEFAULT_COUNTRY] || DEFAULT_NON_WORKING_DAYS_RESPONSE;
  },
  has: (countryDesignation: string): boolean => {
    if (!countryDesignation) {
      return false;
    }

    return marketState.get()[countryDesignation]?.marketHours?.country === countryDesignation;
  },
  set: (data: NonWorkingDaysResponse, countryDesignation: string) => {
    const currentState = marketState.get();
    marketState.set({
      ...currentState,
      [countryDesignation]: data,
    });
  },
  reset: () => marketState.set(initialState),
};
